import { LoadingIndicator } from './component.styles'
export default LoadingIndicator
